import * as noTokenRequests from "../../api/noTokenRequest";
import {START_LOAD, FINISH_LOAD} from "../reducers/source";
import {push} from "./message";


const startLoading = () => {
    return {type: START_LOAD};
};
const finishLoading = (source) => {
    return {type: FINISH_LOAD, payload: source};
};

export const registerSource = () => {
   return dispatch => {
        dispatch(startLoading());
        noTokenRequests.getSource()
            .then(source => {
                dispatch(finishLoading(source))
            })
            .catch(error => {
                dispatch(finishLoading(null));
                dispatch(push(error.message))
            })
    }
};